import { connect } from 'react-redux';
import React, { Component } from 'react';
import actions from '../actions';
import heap from '../modules/heap';
import CreateAccountHeader from '../containers/CreateAccountHeader/CreateAccountHeader.jsx';
import CreateAccount from '../containers/CreateAccount/CreateAccount';
import Footer from '../components/Footer/Footer';
import GetTheApp from '../containers/GetTheApp/GetTheApp';
import Modal from '../components/Modal/Modal';
import PolicyDetails from '../containers/PolicyDetails/PolicyDetails';
import Login from '../containers/Login/Login.jsx';
import Logo from '../components/Logo/Logo';
import StickyHeader from '../components/StickyHeader/StickyHeader';
import WatchYourMail from '../containers/WatchYourMail/WatchYourMail';
import WhatsHappening from '../containers/WhatsHappening/WhatsHappening';
import YourInformation from '../containers/YourInformation/YourInformation';
import { manageMyAccount } from '../settings/links.json';
import IntroTemplate from '../templates/Intro';

export class Renew extends Component {
    headerButtonClick() {
        window.open(
            this.props.app.deploy.env ? manageMyAccount[this.props.app.deploy.env] : '',
            '_blank'
        );
    }

    requestCustomerDetails() {
        this.props.requestCustomerDetails(
            {
                lastName: this.props.customer.lastName,
                accessCode: this.props.customer.accessCode
            },
            {
                accessToken: this.props.customer.apigee.access_token,
                jwtToken: this.props.customer.apigee.jwtToken,
                env: this.props.app.deploy.env
            }
        );
    }

    componentDidMount() {
        setTimeout(
            c => {
                if (!c.props.customer.isAuthenticated) {
                    heap.track('customerPortal', { isAuthenticated: false });
                }
            },
            3000,
            this
        );
    }

    componentDidUpdate() {
        if (
            this.props.customer.isValid &&
            this.props.customer.isAuthenticated &&
            !this.props.details.customerData &&
            !this.props.details.isLoading &&
            !this.props.details.hasError
        ) {
            this.requestCustomerDetails();
        }

        if (this.props.customer.isValid && this.props.customer.isAuthenticated) {
            try {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            } catch (err) {
                console.log('unable to scroll window');
            }
        }

        if (this.props.customer.isAuthenticated) {
            heap.track('customerPortal', { isAuthenticated: true });
        }
    }

    render() {
        return (
            <IntroTemplate
                hasError={this.props.details.hasError}
                header={
                    <StickyHeader>
                        <Logo />
                        {this.props.customer.isAuthenticated ? <CreateAccountHeader /> : <Login />}
                        <Modal
                            isShown={
                                !this.props.customer.hasError &&
                                this.props.customer.isValid &&
                                !this.props.customer.isAuthenticated
                            }
                            canBeClosed
                            type="security"
                        />
                    </StickyHeader>
                }
                footer={<Footer />}>
                <YourInformation />
                <PolicyDetails />
                <WhatsHappening
                    priorCarrier="prior"
                    showPolicyTerminationBulletPoint={false}
                    overwriteText="We are in the process of simplifying our personal insurance operations in your state and these changes will impact your policy. Going forward, your policy will be provided through Safeco Insurance Company, another affiliated underwriting company and backed by the strength of Liberty Mutual Group."
                />
                <WatchYourMail />
                <CreateAccount deploy={this.props.app.deploy} />
                <GetTheApp />
            </IntroTemplate>
        );
    }
}

export function mapStoreToProps(store) {
    return {
        customer: store.customer,
        details: store.details,
        app: store.app
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        requestCustomerDetails: (data, tokens) =>
            dispatch(actions.details.requestCustomerDetails({ tokens, data }))
    };
}

export default connect(
    mapStoreToProps,
    mapDispatchToProps
)(Renew);



// WEBPACK FOOTER //
// ./src/pages/Renew.jsx